<div class="flex" [ngClass]="verticalLayout ? (brandStyle ? 'flex-col gap-3' : 'flex-col gap-2') : 'flex-row gap-4 items-center'">
    <label *ngIf="label" [for]="radioList && radioList.length > 0 ? getRadioId(radioList[0], 0) : ''" class="block font-archivo" [ngClass]="verticalLayout ? (brandStyle ? 'text-gray-1400 text-[1.125rem] font-normal' : 'text-sm text-gray-600') : 'text-sm text-secondary-600'">
        {{label}} <span *ngIf="required" class="text-danger-500">*</span>
    </label>
    
    <label *ngFor="let radio of radioList; let idx = index; trackBy: trackByRadioValue" 
           [for]="getRadioId(radio, idx)" 
           class="flex items-start gap-2" 
           [ngClass]="{ 'opacity-75 cursor-not-allowed': disabled || (radio.disabled ?? false) }">
        <span
            class="w-5 h-5 min-w-[1.25rem] min-h-[1.25rem] shrink-0 mt-[2px] border-2 rounded-full bg-white relative"
            [ngClass]="{
                'border-gray-500': verticalLayout && !brandStyle,
                'border-secondary-500': !verticalLayout || brandStyle,
                'has-[:checked]:border-primary-500': true,
                'cursor-pointer': !disabled && !(radio.disabled ?? false),
                'cursor-not-allowed': disabled || (radio.disabled ?? false)
            }">
            <input 
                [id]="getRadioId(radio, idx)" 
                [name]="getRadioName()" 
                type="radio" 
                class="peer sr-only" 
                [value]="radio.value" 
                [checked]="isSelected(radio.value, selectedValue)"
                [disabled]="disabled || (radio.disabled ?? false)" 
                (change)="handleChange($event)" 
                (blur)="handleBlur()">
            <span
                class="w-3 h-3 peer-checked:block hidden rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                [ngClass]="verticalLayout && !brandStyle ? 'bg-primary-500' : 'bg-orange-500'"></span>
        </span>
        <div class="flex flex-col">
            <p *ngIf="radio.label" 
               class="font-normal font-archivo leading-[1.6]"
               [ngClass]="{
                   'text-[1.125rem] text-gray-1400': brandStyle,
                   'text-[16px] text-gray-500': verticalLayout && !brandStyle,
                   'text-[16px] text-[#444955]': !verticalLayout && !brandStyle,
                   'cursor-pointer': !disabled && !(radio.disabled ?? false),
                   'cursor-not-allowed': disabled || (radio.disabled ?? false)
               }">
                {{ radio.label }}
            </p>
            <p *ngIf="radio.description" 
               class="text-sm"
               [ngClass]="verticalLayout ? 'text-gray-400' : 'text-secondary-400'">
                {{ radio.description }}
            </p>
        </div>
    </label>
</div>
